$(document).ready(function () {
  if ($('.share_facebook').length) {
    $('.share_facebook').click(function (e) {
      if (typeof FB !== 'undefined' && FB !== null) {
        e.preventDefault()
        return FB.ui(
          {
            method: 'share',
            href: window.location.href,
          },
          function () {}
        )
      }
    })
  }
})
